export const adaptAlertDataToServer = ({
  moveIn,
  moveOut,
  minPrice,
  maxPrice,
  propertyTypes,
  cityId,
  mediums,
  cityAreaIds,
  ...rest
}) => ({
  ...rest,
  input: {
    cityId,
    mediums,
    moveIn: moveIn || null,
    moveOut: moveOut || null,
    minPrice: minPrice || null,
    maxPrice: maxPrice || null,
    propertyTypes: propertyTypes || null,
    cityAreaIds: cityAreaIds || []
  }
});

export const adaptAlertDataToClient = (response, key) => {
  const {
    moveIn,
    moveOut,
    minPrice,
    maxPrice,
    propertyTypes,
    cityAreaIds,
    ...rest
  } = response.data[key];

  return {
    ...rest,
    moveIn: moveIn || '',
    moveOut: moveOut || '',
    minPrice: minPrice || 0,
    maxPrice: maxPrice || 0,
    propertyTypes: propertyTypes || [],
    cityAreaIds: cityAreaIds || []
  };
};

export default {
  adaptAlertDataToServer,
  adaptAlertDataToClient
};
